<template>
  <div class="content">
    <h1 class="font-light">Account Activation</h1>

    <!-- Loading placeholder -->
    <div class="panel" v-show="!success && !error.uid && !error.token">
      <div class="placeholder">
        <div class="placeholder-icon">
          <span class="icon">
            <i class="fa-wrapper fa fa-hourglass fa-pulse huge-icon"></i>
          </span>
        </div>
        <space></space>
        <h3 class="placeholder-title font-light">
          Hang on, checking with the server...
        </h3>
        <p>
          We're just checking your details on the server. Shouldn't take too
          long.
        </p>
      </div>
    </div>

    <!-- Success placeholder -->
    <div class="panel" v-show="success">
      <div class="placeholder tas-success-background">
        <div class="placeholder-icon">
          <span class="icon">
            <i class="fa-wrapper fa fa-thumbs-up huge-icon"></i>
          </span>
        </div>
        <space></space>
        <h3 class="placeholder-title font-light">
          Your account has been activated!
        </h3>
        <p>
          You'll be sent back to the login page in a few seconds, otherwise
          <router-link :to="{ name: 'login' }">click here</router-link>
          to login.
        </p>
      </div>
    </div>

    <!-- Error placeholder -->
    <div class="panel" v-show="error.uid || error.token">
      <div class="placeholder tas-error-background">
        <div class="placeholder-icon">
          <span class="icon">
            <i class="fa-wrapper fa fa-exclamation-triangle huge-icon"></i>
          </span>
        </div>
        <space></space>
        <h3 class="placeholder-title font-light">
          Sorry, we ran into a problem.
        </h3>
        <p v-for="(value, key) of error" v-bind:key="'error-' + key">
          <strong>{{ key | titleCase }}:</strong> &nbsp; {{ value }}
        </p>
      </div>
    </div>
  </div>
</template>
<style>
.placeholder.tas-success-background {
  background-color: #4c9c6c;
  color: #f6f9fc;
}
.placeholder.tas-success-background a,
.placeholder.tas-success-background a:hover,
.placeholder.tas-success-background a:visited,
.placeholder.tas-success-background a:active {
  background-color: #4c9c6c;
  color: #f6f9fc;
  font-weight: 600;
}

.placeholder.tas-error-background {
  background-color: #9c4c4c;
  color: #f6f9fc;
}
.placeholder.tas-error-background a,
.placeholder.tas-error-background a:hover,
.placeholder.tas-error-background a:visited,
.placeholder.tas-error-background a:active {
  background-color: #9c4c4c;
  color: #f6f9fc;
}
</style>
<script>
import { mapGetters } from "vuex";
import * as authService from "@/services/auth.service";
import { titleCase } from "@/functions/titleCase.function";
import { handleError } from "@/functions/handleError.function";

export default {
  name: "user-activate",
  components: {},
  data: function() {
    return {
      success: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters("core", ["error"])
  },
  filters: {
    titleCase: function(value) {
      return titleCase(value);
    }
  },
  mounted() {
    this.$store.commit("core/clearErrors");
    this.loading = true;
    authService
      .activateUser(this.$route.params)
      .then(response => {
        this.loading = false;
        if (response.status == 204) {
          this.success = true;
          // Wait 5 seconds then re-direct to the login page
          setTimeout(() => {
            this.$router.push({ name: "login" });
          }, 5000);
        }
      })
      .catch(error => {
        this.loading = false;
        let data = handleError(error);
        this.$store.commit("core/setError", data);
      });
  }
};
</script>
